import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { StaticImage } from '../../../../../image'
import ImgOldWomanGrayHair from '../../../../images/ImgOldWomanGrayHair.png'

export const ErxBonusLandingPageHero: FC = () => {
  const intl = useIntl()

  return (
    <div className="flex justify-center tablet:shrink-0 tablet:grow-0 tablet:basis-2/5">
      <StaticImage
        alt={intl.formatMessage({ id: 'general.link.label.recipe' })}
        className="-ml-32 max-w-md tablet:-ml-24 tablet:max-w-xl"
        src={ImgOldWomanGrayHair}
      />
    </div>
  )
}
